import { Controller } from "@hotwired/stimulus"

// Live Counter Controller - Updates counters in real-time
export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 5000 } // 5 seconds
  }

  connect() {
    console.log("Live counter controller connected", this.urlValue)
    this.startPolling()
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    if (this.pollingTimer) return
    
    this.pollingTimer = setInterval(() => {
      this.updateCounter()
    }, this.intervalValue)
  }

  stopPolling() {
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer)
      this.pollingTimer = null
    }
  }

  async updateCounter() {
    try {
      const response = await fetch(this.urlValue, {
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      if (response.ok) {
        const data = await response.json()
        // Handle both direct count value and nested count property
        const count = typeof data === 'number' ? data : (data.count || 0)
        this.animateCounterUpdate(count)
      } else if (response.status === 406) {
        console.warn("Live counter endpoint does not support JSON format")
        this.stopPolling() // Stop polling if endpoint doesn't support JSON
      } else {
        console.warn(`Live counter update failed: ${response.status} ${response.statusText}`)
      }
    } catch (error) {
      console.error("Error updating counter:", error)
    }
  }

  animateCounterUpdate(newCount) {
    const currentCount = parseInt(this.element.textContent) || 0
    
    if (currentCount !== newCount) {
      // Add animation class
      this.element.classList.add('animate-pulse')
      
      // Update the count with animation
      this.countUp(currentCount, newCount)
      
      // Remove animation class after animation
      setTimeout(() => {
        this.element.classList.remove('animate-pulse')
      }, 500)
    }
  }

  countUp(start, end) {
    const duration = 300 // milliseconds
    const steps = 20
    const stepValue = (end - start) / steps
    const stepDuration = duration / steps
    
    let current = start
    let step = 0
    
    const timer = setInterval(() => {
      step++
      current += stepValue
      
      if (step >= steps) {
        this.element.textContent = end
        clearInterval(timer)
      } else {
        this.element.textContent = Math.round(current)
      }
    }, stepDuration)
  }
}